import { object } from "zod";

export const deleteControlPortIntegration = {
  name: "deleteControlPortIntegration" as const,
  input: object({}),
  output: object({}),
};
